export default {
  state: {
    packTypes: [],
    loading: false,
  },
  getters: {
    packTypes: state => state.packTypes,
    loading: state => state.loading,
  },
  mutations: {
    setPackTypes(state, packTypes) {
      state.packTypes = packTypes;
    },
    setLoading(state, display) {
      state.loading = display;
    }
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const packTypes = await axios.get('api/pack-types');
        commit('setPackTypes', packTypes);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetch({ commit }, id) {
      try {
        return await axios.get('api/pack-types/' + id);
      } catch (e) {
      }
    },

    async add({ commit }, payLoad) {
        await axios.post('api/pack-types', payLoad);
    },

    async update({ commit }, payLoad) {
        await axios.put('api/pack-types', payLoad);
    },

    async delete({}, id) {
      await axios.delete('api/pack-types/' + id);
    }
  },
};
